import script from "./Vistoriar.vue?vue&type=script&setup=true&lang=js"
export * from "./Vistoriar.vue?vue&type=script&setup=true&lang=js"

import "./Vistoriar.vue?vue&type=style&index=0&id=454a0e88&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-454a0e88"]])

export default __exports__